import script from "./SwiperImg.vue?vue&type=script&setup=true&lang=js"
export * from "./SwiperImg.vue?vue&type=script&setup=true&lang=js"

import "./SwiperImg.vue?vue&type=style&index=0&id=52885829&lang=scss&scoped=true"

import exportComponent from "/Users/rioschan/Downloads/event-2022electrolux-main/vue-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52885829"]])

export default __exports__